<div
  *ngIf="currentUser$ | async as user"
  class="container rb-nav-panel"
  [@menuInOut]="state"
>
  <kendo-panelbar *ngIf="user.navMenuConfig as config" [selectable]="false">
    <kendo-panelbar-item
      *ngIf="config.home.enabled"
      [title]="config.home.label!"
      [routerLink]="[config.home.link]"
      [selected]="currentRoute === config.home.link"
    ></kendo-panelbar-item>

    <kendo-panelbar-item
      *ngIf="config.dashboard.enabled"
      [title]="config.dashboard.label!"
      [routerLink]="[config.dashboard.link]"
      [selected]="currentRoute === config.dashboard.link"
    ></kendo-panelbar-item>

    <kendo-panelbar-item
      *ngIf="config.ceDashboard.enabled"
      [title]="config.ceDashboard.label!"
      [routerLink]="[config.ceDashboard.link]"
      [selected]="currentRoute === config.ceDashboard.link"
    ></kendo-panelbar-item>

    <!-- MFP/Rebate File Monitoring Dashboard -->
    <!-- <kendo-panelbar-item
      *ngIf="config.mfpRebateFileMonitoring.enabled"
      [title]="config.mfpRebateFileMonitoring.label!"
      [routerLink]="[config.mfpRebateFileMonitoring.link]"
      [selected]="currentRoute === config.mfpRebateFileMonitoring.link"
    >
    </kendo-panelbar-item> -->

    <!-- MFP/Rebate Reports -->
    <kendo-panelbar-item
      *ngIf="config.mfpRebateReports.enabled"
      [title]="config.mfpRebateReports.label!"
      [routerLink]="[config.mfpRebateReports.link]"
      [selected]="
        currentRoute === config.mfpRebateReports.link ||
        currentRoute.endsWith('mfp-claim-detail-report') ||
        currentRoute.endsWith('rebate-claim-detail-report') ||
        currentRoute.endsWith('rebate-claim-status-report') ||
        currentRoute.endsWith('payment-reconciliation-report')
      "
    >
    </kendo-panelbar-item>

    <!-- MFP Management -->
    <kendo-panelbar-item
      *ngIf="config.mfpManagement.enabled"
      [title]="config.mfpManagement.label!"
      [routerLink]="[config.mfpManagement.link]"
      [selected]="currentRoute === config.mfpManagement.link"
    >
    </kendo-panelbar-item>

    <!-- 340B Rebate Management -->
    <kendo-panelbar-item
      *ngIf="config.rebateManagement.enabled"
      [title]="config.rebateManagement.label!"
      [routerLink]="[config.rebateManagement.link]"
      [selected]="currentRoute === config.rebateManagement.link"
    >
    </kendo-panelbar-item>

    <!-- Admin -->
    <kendo-panelbar-item
      *ngIf="config.admin.enabled"
      [title]="config.admin.label!"
      [expanded]="
        expanded([
          '/user-management',
          '/hcpcs-management',
          '/state-carve-in-management',
          '/state-drug-exclusion-management',
          '/inbound-sms-management'
        ])
      "
    >
      <kendo-panelbar-item
        *ngIf="config.adminUserList.enabled"
        [title]="config.adminUserList.label!"
        [routerLink]="[config.adminUserList.link]"
        [selected]="currentRoute === config.adminUserList.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.adminAddUser.enabled"
        [title]="config.adminAddUser.label!"
        [routerLink]="[config.adminAddUser.link]"
        [selected]="currentRoute === config.adminAddUser.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.hcpcs.enabled"
        [title]="config.hcpcs.label!"
        [routerLink]="[config.hcpcs.link]"
        [selected]="currentRoute === config.hcpcs.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.stateCarveIn.enabled"
        [title]="config.stateCarveIn.label!"
        [routerLink]="[config.stateCarveIn.link]"
        [selected]="currentRoute === config.stateCarveIn.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.stateDrugExclusion.enabled"
        [title]="config.stateDrugExclusion.label!"
        [routerLink]="[config.stateDrugExclusion.link]"
        [selected]="currentRoute === config.stateDrugExclusion.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.inboundSms.enabled"
        [title]="config.inboundSms.label!"
        [routerLink]="[config.inboundSms.link]"
        [selected]="currentRoute === config.inboundSms.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- Manufacturer -->
    <kendo-panelbar-item
      *ngIf="config.mfg.enabled"
      [title]="config.mfg.label!"
      [expanded]="
        expanded([
          '/manufacturer-management',
          '/manufacturer-global-config-management'
        ])
      "
    >
      <kendo-panelbar-item
        *ngIf="config.mfgList.enabled"
        [title]="config.mfgList.label!"
        [routerLink]="[config.mfgList.link]"
        [selected]="
          currentRoute === config.mfgList.link ||
          currentRoute.indexOf(
            '/manufacturer-management/manufacturer-details/'
          ) > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.mfgAdd.enabled"
        [title]="config.mfgAdd.label!"
        [routerLink]="[config.mfgAdd.link]"
        [selected]="currentRoute === config.mfgAdd.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.mfgPermissions.enabled"
        [title]="config.mfgPermissions.label!"
        [routerLink]="[config.mfgPermissions.link]"
        [selected]="currentRoute === config.mfgPermissions.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.mfgDrugLists.enabled"
        [title]="config.mfgDrugLists.label!"
        [routerLink]="[config.mfgDrugLists.link]"
        [selected]="currentRoute === config.mfgDrugLists.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.mfgDetails.enabled && config.mfgDetails.link"
        [title]="config.mfgDetails.label!"
        [routerLink]="[config.mfgDetails.link]"
        [selected]="currentRoute === config.mfgDetails.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.vendorConfiguration.enabled"
        [title]="config.vendorConfiguration.label!"
        [routerLink]="[config.vendorConfiguration.link]"
        [selected]="currentRoute === config.vendorConfiguration.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.mfrSubmission.enabled"
        [title]="config.mfrSubmission.label!"
        [routerLink]="[config.mfrSubmission.link]"
        [selected]="currentRoute === config.mfrSubmission.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>
    <kendo-panelbar-item
      *ngIf="
        config.vendorConfiguration.enabled && (isCEUser || isHealthSystemUser)
      "
      [title]="config.vendorConfiguration.label!"
      [routerLink]="[config.vendorConfiguration.link]"
      [selected]="currentRoute === config.vendorConfiguration.link"
      class="panelbar-subitem"
    >
    </kendo-panelbar-item>

    <!-- Customer -->
    <kendo-panelbar-item
      *ngIf="config.customer.enabled"
      [title]="config.customer.label!"
      [expanded]="
        expanded([
          '/customer-management',
          '/audit-customer-management',
          '/health-system-management',
          '/pharmacy-chain-management'
        ]) && !expanded(['/claims/review'])
      "
    >
      <kendo-panelbar-item
        *ngIf="config.customerList.enabled"
        [title]="config.customerList.label!"
        [routerLink]="[config.customerList.link]"
        [selected]="
          currentRoute === config.customerList.link ||
          currentRoute.indexOf(customerDetailsUrlDefault + '/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.auditCustomerList.enabled"
        [title]="config.auditCustomerList.label!"
        [routerLink]="[config.auditCustomerList.link]"
        [selected]="
          currentRoute === config.auditCustomerList.link ||
          currentRoute.indexOf(customerDetailsUrlAudit340B + '/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.healthcareProviderList.enabled"
        [title]="config.healthcareProviderList.label!"
        [routerLink]="[config.healthcareProviderList.link]"
        [selected]="
          currentRoute === config.healthcareProviderList.link ||
          currentRoute.indexOf(customerDetailsUrlHealthcareProvider + '/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.pharmacyChainList.enabled"
        [title]="config.pharmacyChainList.label!"
        [routerLink]="[config.pharmacyChainList.link]"
        [selected]="
          currentRoute === config.pharmacyChainList.link ||
          currentRoute.indexOf(customerDetailsUrlPharmacyChain + '/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.customerAdd.enabled"
        [title]="config.customerAdd.label!"
        [routerLink]="[config.customerAdd.link]"
        [selected]="currentRoute === config.customerAdd.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.customerDetails.enabled && config.customerDetails.link"
        [title]="config.customerDetails.label!"
        [routerLink]="[config.customerDetails.link]"
        [selected]="currentRoute === config.customerDetails.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- Third Party Administrators (tpa) -->
    <kendo-panelbar-item
      *ngIf="config.tpa.enabled"
      [title]="config.tpa.label!"
      [expanded]="expanded(['/tpa'])"
    >
      <kendo-panelbar-item
        *ngIf="config.tpaList.enabled"
        [title]="config.tpaList.label!"
        [routerLink]="[config.tpaList.link]"
        [selected]="
          currentRoute === config.tpaList.link ||
          currentRoute.indexOf('/tpa/details/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>

      <kendo-panelbar-item
        *ngIf="config.tpaAdd.enabled"
        [title]="config.tpaAdd.label!"
        [routerLink]="[config.tpaAdd.link]"
        [selected]="currentRoute === config.tpaAdd.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.tpaDetails.enabled && config.tpaDetails.link"
        [title]="config.tpaDetails.label!"
        [routerLink]="[config.tpaDetails.link]"
        [selected]="currentRoute === config.tpaDetails.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- Covered Entities (ce) -->
    <kendo-panelbar-item
      *ngIf="config.ce.enabled"
      [title]="config.ce.label!"
      [expanded]="expanded(['/ce'])"
    >
      <kendo-panelbar-item
        *ngIf="config.ceList.enabled"
        [title]="config.ceList.label!"
        [routerLink]="[config.ceList.link]"
        [selected]="
          currentRoute === config.ceList.link ||
          currentRoute.indexOf('/ce/details/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.ceDetails.enabled && config.ceDetails.link"
        [title]="config.ceDetails.label!"
        [routerLink]="[config.ceDetails.link]"
        [selected]="currentRoute === config.ceDetails.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.ceOnboarding.enabled && config.ceOnboarding.link"
        [title]="config.ceOnboarding.label!"
        [routerLink]="[config.ceOnboarding.link]"
        [selected]="currentRoute === config.ceOnboarding.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- MFP Pharmacy -->
    <kendo-panelbar-item
      *ngIf="config.mfpPharmacy.enabled"
      [title]="config.mfpPharmacy.label!"
      [expanded]="expanded(['/mfp-pharmacy'])"
    >
      <kendo-panelbar-item
        *ngIf="config.mfpPharmacyList.enabled"
        [title]="config.mfpPharmacyList.label!"
        [routerLink]="[config.mfpPharmacyList.link]"
        [selected]="
          currentRoute === config.mfpPharmacyList.link ||
          currentRoute.indexOf('/mfp-pharmacy/details/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.mfpPharmacyAdd.enabled"
        [title]="config.mfpPharmacyAdd.label!"
        [routerLink]="[config.mfpPharmacyAdd.link]"
        [selected]="currentRoute === config.mfpPharmacyAdd.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="
          config.mfpPharmacyDetails.enabled && config.mfpPharmacyDetails.link
        "
        [title]="config.mfpPharmacyDetails.label!"
        [routerLink]="[config.mfpPharmacyDetails.link]"
        [selected]="currentRoute === config.mfpPharmacyDetails.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- Contract -->
    <kendo-panelbar-item
      *ngIf="config.contract.enabled"
      [title]="config.contract.label!"
      [expanded]="expanded(['/contract-management'])"
    >
      <kendo-panelbar-item
        *ngIf="config.contractList.enabled"
        [title]="config.contractList.label!"
        [routerLink]="[config.contractList.link]"
        [selected]="
          currentRoute === config.contractList.link ||
          currentRoute.indexOf('/contract-management/details/') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.contractAdd.enabled"
        [title]="config.contractAdd.label!"
        [routerLink]="[config.contractAdd.link]"
        [selected]="currentRoute === config.contractAdd.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- Benefit design -->
    <kendo-panelbar-item
      *ngIf="config.bd.enabled"
      [expanded]="expanded(['/benefit-designs-management'])"
      [selected]="false"
      [title]="config.bd.label!"
    >
      <kendo-panelbar-item
        *ngIf="config.bdList.enabled"
        [title]="config.bdList.label!"
        [selected]="currentRoute === config.bdList.link"
        [routerLink]="[config.bdList.link]"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.bdAdd.enabled"
        [title]="config.bdAdd.label!"
        [selected]="currentRoute === config.bdAdd.link"
        [routerLink]="[config.bdAdd.link]"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- Claims -->
    <kendo-panelbar-item
      *ngIf="config.claims.enabled"
      [title]="config.claims.label!"
      [expanded]="expanded(['/claims'])"
    >
      <kendo-panelbar-item
        *ngIf="config.claimsUpload.enabled"
        [title]="config.claimsUpload.label!"
        [routerLink]="[config.claimsUpload.link]"
        [selected]="
          [config.claimsUpload.link, '/claims/upload-statistics'].includes(
            currentRoute
          )
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.claimsUploadLog.enabled"
        [title]="config.claimsUploadLog.label!"
        [routerLink]="[config.claimsUploadLog.link]"
        [selected]="currentRoute === config.claimsUploadLog.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
      <kendo-panelbar-item
        *ngIf="config.claimsReview.enabled"
        [title]="config.claimsReview.label!"
        [routerLink]="[config.claimsReview.link]"
        [selected]="
          currentRoute === config.claimsReview.link ||
          currentRoute.indexOf('claims/review') > -1
        "
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- MFP -->
    <kendo-panelbar-item
      *ngIf="config.mfp.enabled"
      [title]="config.mfp.label!"
      [expanded]="expanded(['/claims'])"
    >
      <kendo-panelbar-item
        *ngIf="config.mfpClaims.enabled"
        [title]="config.mfpClaims.label!"
        [routerLink]="[config.mfpClaims.link]"
        [selected]="currentRoute === config.mfpClaims.link"
        class="panelbar-subitem"
      >
      </kendo-panelbar-item>
    </kendo-panelbar-item>

    <!-- Prescriber Search -->
    <kendo-panelbar-item
      *ngIf="config.prescriberSearch.enabled"
      [title]="config.prescriberSearch.label!"
      (click)="openPrescriberDetails()"
    >
    </kendo-panelbar-item>

    <!-- Pharmacy Search -->
    <kendo-panelbar-item
      *ngIf="config.pharmacySearch.enabled"
      [title]="config.pharmacySearch.label!"
      (click)="openPharmacyDetails()"
    >
    </kendo-panelbar-item>

    <!-- 340B Claim Search -->
    <kendo-panelbar-item
      *ngIf="config.auditClaimSearch.enabled"
      [title]="config.auditClaimSearch.label!"
      (click)="openAuditClaimSearch()"
    >
    </kendo-panelbar-item>

    <!-- Validate Chargeback -->
    <kendo-panelbar-item
      *ngIf="config.validateChargeback.enabled"
      [title]="config.validateChargeback.label!"
      [routerLink]="[config.validateChargeback.link]"
      [selected]="currentRoute === config.validateChargeback.link"
    >
    </kendo-panelbar-item>

    <!-- MFP Drugs 
    <kendo-panelbar-item
      *ngIf="config.mfpDrugs.enabled && config.mfpDrugs.link"
      [title]="config.mfpDrugs.label!"
      [routerLink]="[config.mfpDrugs.link]"
      [selected]="currentRoute === config.mfpDrugs.link"
    >
    </kendo-panelbar-item>-->

    <!-- Dispute Center -->
    <kendo-panelbar-item
      *ngIf="config.disputeCenter.enabled"
      [title]="config.disputeCenter.label!"
      [routerLink]="[config.disputeCenter.link]"
      [selected]="currentRoute === config.disputeCenter.link"
    >
    </kendo-panelbar-item>

    <!-- Dispute Dashboard -->
    <kendo-panelbar-item
      *ngIf="config.disputeDashboard.enabled"
      [title]="config.disputeDashboard.label!"
      [routerLink]="[config.disputeDashboard.link]"
      [selected]="currentRoute === config.disputeDashboard.link"
    >
    </kendo-panelbar-item>
    <kendo-panelbar-item
      *ngIf="config.claimReconciliation.enabled"
      [title]="config.claimReconciliation.label!"
      [routerLink]="[config.claimReconciliation.link]"
      [selected]="currentRoute === config.claimReconciliation.link"
    >
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>
